<template>
  <div>
    
    <v-card>
      <!-- Toolbar. -->
      <v-toolbar dense color="primary" dark align="center">
        <!-- Titolo. -->
        <v-toolbar-title>Gestione Filtri</v-toolbar-title>
        <v-spacer/>

        <!-- Pulsante per aggiungere modulo. 
        <v-tooltip bottom v-if="nuovo_modulo == false">
          <template v-slot:activator="{ on }">
            <v-btn small light v-on="on" v-show="!nuovo_filtro"
            @click="aggiungiNuovoModulo();">
              <v-icon color="primary"> mdi-table-plus </v-icon>
            </v-btn>
          </template>
          <span>Nuovo modulo per filtri</span>
        </v-tooltip>-->

         <!-- Pulsante per annullare l'aggiunta del modulo. 
        <v-tooltip v-else bottom>
          <template v-slot:activator="{ on }">
            <v-btn small light v-on="on"
            @click="nuovo_modulo = false; modulo = ''; lista_filtri = []; lista_filtri_dettaglio = []">
              <v-icon color="primary"> mdi-table </v-icon>
            </v-btn>
          </template>
          <span>Elenco moduli già presenti</span>
        </v-tooltip>-->

        <!-- Pulsante per aggiungere un nuovo set di filtri. -->
        <!-- (attivo se "nuovo_modulo" è disattivato, poiché deve lavorare sul set filtri "Default"). -->
        <v-tooltip bottom v-if="nuovo_filtro == false">
          <template v-slot:activator="{ on }">
            <v-btn small light class="ml-5" v-on="on"
            @click="aggiungiFiltro" v-show="!nuovo_modulo">
              <v-icon color="primary"> mdi-filter-plus </v-icon>
            </v-btn>
          </template>
          <span>Nuovo set di filtri</span>
        </v-tooltip>
        
        <!-- Pulsante per annullare l'aggiunta del set di filtri. -->
        <v-tooltip v-else bottom>
          <template v-slot:activator="{ on }">
            <v-btn small light v-on="on"
            @click="nuovo_filtro = false; id_filtro_sel = null; lista_filtri_dettaglio = []; getFiltri();">
              <v-icon color="primary"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <span>Elenco filtri già presenti</span>
        </v-tooltip>

        <!-- Pulsante per aggiungere un nuovo filtro dettaglio. -->
        <!-- Visibile solamente per il modulo "Default". -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small light class="ml-5" v-on="on"
            @click="aggiungiFiltroDettaglio"
            v-show="nome_filtro_sel == DEFAULT">
              <v-icon color="primary"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Nuovo filtro</span>
        </v-tooltip>

        <!-- Salva le modifiche. -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="setFiltro" small light class="ml-5">
              <v-icon color="success"> mdi-floppy </v-icon>
            </v-btn>
          </template>
          <span>Salva</span>
        </v-tooltip>

        <v-spacer/>
        <!-- Pulsante indietro. -->
        <v-btn small light @click="$router.push('/home/amministrazione')">
          <v-icon color="error">mdi-keyboard-backspace</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row align="center" justify="center">

          <!-- Se non è in "nuovo_modulo", mostra una combobox con tutti i moduli. 
          <v-col v-if="nuovo_modulo == false" cols="6">
            <v-autocomplete :readonly="nuovo_filtro"
              hide-details
              label="Modulo per filtro"
              item-text="modulo"
              item-value="modulo"
              :items="lista_moduli"
              v-model="modulo"
              @change="lista_filtri_dettaglio = []; id_filtro_sel = null; nome_filtro_sel = ''; getFiltri();">
              <template v-slot:item="{ item }">
                <div style="text-align: left">
                  {{ item.modulo }}
                </div>
              </template>
            </v-autocomplete>
          </v-col> -->
          
          <!-- Altrimenti mostra un text field per inserire il nome del nuovo modulo. 
          
          <v-col v-else cols="6">
            <v-text-field hide-details type="text"
              label="Inserire nome nuovo modulo per filtro"
              v-model="modulo">
            </v-text-field>
          </v-col> -->
          
          <v-col cols="6">
            <v-text-field hide-details readonly
              type="text"
              label="Modulo"
              v-model="modulo">
            </v-text-field>
          </v-col>

          <!-- Se è in "nuovo_modulo", rende readonly e obbliga ad impostare "Default". -->
          <v-col v-if="!nuovo_filtro" cols="3">
            <v-autocomplete
              hide-details
              label="Set di filtri"
              item-text="des_filtro"
              item-value="id_filtro"
              :items="lista_filtri"
              :readonly="nuovo_modulo"
              v-model="id_filtro_sel"
              @change="aggiornaFiltriDettaglio();">
              <!--<template v-slot:item="{ item }">
                <div style="text-align: left">
                  {{ item.des_filtro }}
                </div>
              </template>-->
            </v-autocomplete>
          </v-col>

          <!-- Se è in "nuovo_filtro" mostra un text field per inserire il nome del nuovo filtro. -->
          <v-col v-else cols="3">
            <v-text-field hide-details type="text"
              label="Inserire nome nuovo per set di filtri"
              v-model="lista_filtri[findIndexFromId(id_filtro_sel)].des_filtro">
            </v-text-field>
          </v-col>  

          <!-- Pulsante per impostare l'ORDER BY. -->
          <v-tooltip bottom v-if="nome_filtro_sel && !nuovo_filtro">
            <template v-slot:activator="{ on }">
              <v-btn small light style="position: relative; top: 10px; margin-right: 5px;" v-on="on"
              @click="
                dialog_order_by = true;
                lista_order_by = [];
                if(lista_filtri[findIndexFromId(id_filtro_sel)])
                  convertiOrderBy(false, lista_filtri[findIndexFromId(id_filtro_sel)].order_by);
                ">
                <v-icon color="primary"> mdi-order-alphabetical-ascending </v-icon>
              </v-btn>
            </template>
            <span>Ordine</span>
          </v-tooltip>

          <!-- Pulsante per aggiornare con il set di filtri default. -->
          <v-tooltip bottom v-if="nome_filtro_sel && nome_filtro_sel != DEFAULT && !nuovo_filtro">
            <template v-slot:activator="{ on }">
              <v-btn small light style="position: relative; top: 10px;" v-on="on"
              @click="aggiornaDaDefault">
                <v-icon color="primary"> mdi-refresh </v-icon>
              </v-btn>
            </template>
            <span>Aggiorna da "Default"</span>
          </v-tooltip>

          <!-- Pulsante per eliminare set di filtri. -->
          <v-tooltip bottom v-if="nome_filtro_sel && nome_filtro_sel != DEFAULT && !nuovo_filtro">
            <template v-slot:activator="{ on }">
              <v-btn small light style="position: relative; top: 10px; margin-left: 5px;" v-on="on"
              @click="dialog_elimina_set_filtri = true">
                <v-icon color="error"> mdi-trash-can </v-icon>
              </v-btn>
            </template>
            <span>Elimina set di filtri</span>
          </v-tooltip>
        
        </v-row>

        <!-- Mostra i filtri dettaglio. -->
        <v-data-table :headers="headers" :items="lista_filtri_dettaglio"
        disable-sort>

          <!-- Pulsante sposta su. -->
          <template v-slot:[`item.up`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ma-0 pa-0" small v-bind="attrs" v-on="on"
                :disabled="lista_filtri_dettaglio.indexOf(item) == 0"
                @click="spostaOrdineFiltro(true, item);">
                  <v-icon color="primary">mdi-arrow-up</v-icon>
                </v-btn>
              </template>
              <span> Sposta su </span>
            </v-tooltip>
          </template>

          <!-- Pulsante sposta giù. -->
          <template v-slot:[`item.down`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ma-0 pa-0" small v-bind="attrs" v-on="on"
                :disabled="lista_filtri_dettaglio.indexOf(item) == lista_filtri_dettaglio.length - 1"
                @click="spostaOrdineFiltro(false, item);">
                  <v-icon color="primary">mdi-arrow-down</v-icon>
                </v-btn>
              </template>
              <span> Sposta giù </span>
            </v-tooltip>
          </template>

          <!-- Descrizione filtro. -->
          <template v-slot:[`item.des_filtro_dettaglio`]="{ item }">
            <v-text-field dense v-model="item.des_filtro_dettaglio"
            :disabled="!item.validita">
            </v-text-field>
          </template>

          <!-- Campo tabella (modificabile solo da "Default"). -->
          <template v-slot:[`item.campo`]="{ item }">
            <v-text-field dense
            :readonly="nome_filtro_sel != DEFAULT || nuovo_filtro"
            :disabled="!item.validita"
            v-model="item.campo">
            </v-text-field>
          </template>

          <!-- Operatore relazionale. -->
          <template v-slot:[`item.operatore`]="{ item }">
            <v-autocomplete dense
            :items="lista_operatori_rel" 
            item-text="des"
            item-value="val_int"
            :disabled="!item.validita"
            v-model="item.operatore">
             <!-- <template v-slot:item="{ item }">
                <div style="text-align: left">
                  {{ item.des }}
                </div>
              </template> -->
            </v-autocomplete>
          </template>

          <!-- Tipo oggetto del valore da confrontare. -->
          <template v-slot:[`item.tipo_oggetto`]="{ item }">
            <v-autocomplete dense
            :items="lista_tipi_oggetto" 
            item-text="des"
            item-value="val_int"
            :disabled="!item.validita"
            v-model="item.tipo_oggetto"
            @change="item.valore = null;
                     if(item.tipo_oggetto != TipoOggetto.MULTI_SELECT &&
                        item.tipo_oggetto != TipoOggetto.SELECT &&
                        item.tipo_oggetto != TipoOggetto.SELECT_NO_NULLABLE) {
                          item.query_tabella = null; 
                          item.lista_query = [];
                     }">
             <!-- <template v-slot:item="{ item }">
                <div style="text-align: left">
                  {{ item.des }}
                </div>
              </template> -->
            </v-autocomplete>
          </template>

          <!-- Valore (tipo oggetto a seconda di quello selezionato). -->
          <template v-slot:[`item.valore`]="{ item }">
            <v-text-field dense v-if="item.tipo_oggetto == TipoOggetto.TEXT_FIELD"
            :disabled="!item.validita"
            v-model="item.valore" />

            <v-text-field type="date" dense v-if="item.tipo_oggetto == TipoOggetto.DATA_PICKER"
            :disabled="!item.validita"
            v-model="item.valore" />

            <template v-if="item.tipo_oggetto == TipoOggetto.DATA_QUERY">
              <v-card-text class="d-flex ma-0 pa-0">
                <v-text-field dense class="mr-4" type="number" :disabled="!item.validita"
                reverse
                :value="convertiDataQuery(item.valore, true)"
                @change="(e) => {aggiornaValoreDataQuery(e, item, true);}"></v-text-field>

                <v-autocomplete dense :disabled="!item.validita"
                :items="lista_date"
                item-text="text"
                item-value="value"
                :value="convertiDataQuery(item.valore, false)"
                @change="(e) => {aggiornaValoreDataQuery(e, item, false);}">
                <!-- <template v-slot:item="{ item }">
                  <div style="text-align: left">
                    {{ item.text }}
                  </div>
                </template> -->
                </v-autocomplete>
              </v-card-text>
            </template>

            <template v-if="item.tipo_oggetto == TipoOggetto.SELECT ||
                            item.tipo_oggetto == TipoOggetto.SELECT_NO_NULLABLE ||
                            item.tipo_oggetto == TipoOggetto.MULTI_SELECT">
              <v-card-text class="ml-0 mr-0 pl-0 pr-0">
                <v-row>
                  <v-col class="pt-0 pb-0 mt-0 mb-0" cols="8">
                    <v-autocomplete hide-details dense
                    :multiple="item.tipo_oggetto == TipoOggetto.MULTI_SELECT"
                    :disabled="!item.validita"
                    :items="item.lista_query"
                    item-text="text"
                    item-value="value"
                    v-model="item.valore">
                    <!-- <template v-slot:item="{ item }">
                      <div style="text-align: left">
                        {{ item.text }}
                      </div>
                    </template> -->
                    </v-autocomplete>
                  </v-col>
                  <v-col class="pt-0 pb-0 mt-0 mb-0" cols="4">
                    <!-- Pulsante per riempire la multi-select con query. -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small light v-on="on" v-bind="attrs"
                        @click="
                        dialog_query = true;
                        item_query_sel = item;
                        query_valori.query = item_query_sel.query_tabella;
                        ">
                          <v-icon color="primary"> mdi-database-search </v-icon>
                        </v-btn>
                      </template>
                      <span>Query valori</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
                    <v-text-field hide-details dense
                    :disabled="!item.validita"
                    v-model="item.valore" />
                  </v-col>
                </v-row>
              </v-card-text>
            </template>

          </template>

           <!-- Post query -->
          <template v-slot:[`item.post_query`]="{ item }">
            <v-text-field dense
            v-model="item.post_query">
            </v-text-field>
          </template>

          <!-- Pulsante visibilità. -->
          <template v-slot:[`item.visible`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">

                <v-btn small v-if="item.visible == 1" v-bind="attrs" v-on="on" :disabled="!item.validita"
                  @click="item.visible = 0">
                  <v-icon color="primary">mdi-eye</v-icon>
                </v-btn>

                <v-btn small v-else v-bind="attrs" v-on="on" :disabled="!item.validita"
                  @click="item.visible = 1">
                  <v-icon color="error">mdi-eye-off</v-icon>
                </v-btn>
              </template>
              <span>{{ item.visible == 0 ? "Invisibile" : "Visibile" }}</span>
            </v-tooltip>
          </template>

          <!-- Tipo valore header. -->
          <template v-slot:[`item.tipo_filtro`]="{ item }">
            <v-text-field dense
            :disabled="!item.validita"
            v-model="item.tipo_filtro">
            </v-text-field>
          </template>

          <!-- Pulsante attiva / disattiva. -->
          <template v-slot:[`item.validita`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">

                <v-btn small v-if="item.validita == 1" v-bind="attrs" v-on="on"
                  @click="item.validita = 0">
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>

                <v-btn small v-else v-bind="attrs" v-on="on"
                  @click="item.validita = 1">
                  <v-icon color="primary">mdi-undo</v-icon>
                </v-btn>
              </template>
              <span>{{ item.validita == 1 ? "Disattiva" : "Riattiva" }}</span>
            </v-tooltip>


          </template>

        </v-data-table>
      </v-card-text>
    </v-card>
    
    <!-- Popup query per riempire multi-select. -->
    <v-dialog persistent v-model="dialog_query" width="800px">
      <v-card>
        <!-- Toolbar. -->
        <v-toolbar dense color="primary" dark align="center">
         <v-toolbar-title> Query </v-toolbar-title>
         <v-spacer/>

        <!-- Conferma le modifiche. -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small light class="ml-5" :disabled="!query_valori.is_analyzed"
             @click="
             dialog_query = false;
             item_query_sel.query_tabella = query_valori.query">
              <v-icon color="success"> mdi-check </v-icon>
            </v-btn>
          </template>
          <span>Conferma</span>
        </v-tooltip>

        <v-spacer/>
        <!-- Pulsante indietro. -->
        <v-btn small light
        @click="dialog_query = false;
        query_valori.query = '';">
          <v-icon color="error">mdi-keyboard-backspace</v-icon>
        </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- Text editor per query. -->
          <QueryEditor
          :key="query_valori.query"
          v-model="query_valori"
          @analyze="analizzaQuery"/>

          <!-- Pulsante per eseguire la query. -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mr-5" v-on="on" v-bind="attrs" :disabled="!query_valori.is_analyzed"
              @click="eseguiQuery(item_query_sel, true); item_query_sel.valore = null"> Esegui </v-btn>
            </template>
            <span>Esegui query</span>
          </v-tooltip>

          <!-- Lista risultato query. -->
          <v-data-table v-if="item_query_sel" fixed-header class="mt-1"
          :headers="headers_query" :items="item_query_sel.lista_query" disable-sort
          height="200px"/>

        </v-card-text>
      </v-card>

      <!-- Overlay caricamento. -->
      <v-overlay color="rgba(0, 0, 0, 1)" style="position: absolute" :value="caricamento_dati_dialog">
        <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
        <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
      </v-overlay>

    </v-dialog>

    <!-- Popup inserimento ORDER BY. -->
    <v-dialog persistent v-model="dialog_order_by" width="680px">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text"
        style="position: sticky; top: 0px; z-index: 1">

          <!-- Titolo. -->
          <v-toolbar-title>Ordine</v-toolbar-title>
          <v-spacer />

          <!-- Pulsante aggiunta nuovo ordine. -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small light v-bind="attrs" v-on="on"
              @click="lista_order_by.push({campo: '', ordine: ''});">
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Nuovo elemento</span>
          </v-tooltip>

          <!-- Pulsante di salvataggio. -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on" class="ml-5"
              @click="checkSalvaOrderBy">
                <v-icon color="success"> mdi-check </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>

          <v-spacer />

          <!-- Pulsante di annullamento. -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on"
              @click="dialog_order_by = false">
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>

        <v-data-table :headers="headers_order_by" :items="lista_order_by"
         disable-sort>

          <!-- Campo order by. -->
          <template v-slot:[`item.campo`]="{ item }">
            <v-text-field dense v-model="item.campo">
            </v-text-field>
          </template>

          <!-- Ordine order by. -->
          <template v-slot:[`item.ordine`]="{ item }">
            <v-select dense :items="lista_ordini_order_by"
            item-text="text" item-value="value"
            v-model="item.ordine">
            </v-select>
          </template>

          <!-- Pulsante elimina. -->
          <template v-slot:[`item.elimina`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small v-bind="attrs" v-on="on"
                  @click="lista_order_by.splice(lista_order_by.indexOf(item), 1)">
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Elimina</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <!-- Snackbar. -->
        <SnackbarQV ref="SnackbarQVOrderBy"/>
      </v-card>
    </v-dialog>

    <!-- Popup conferma eliminazione set filtri. -->
    <v-dialog v-model="dialog_elimina_set_filtri" width="unset">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text"
        style="position: sticky; top: 0px; z-index: 1">

          <!-- Titolo. -->
          <v-toolbar-title>Elimina</v-toolbar-title>
          <v-spacer />

          <!-- Pulsante di conferma. -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on"
                @click="dialog_elimina_set_filtri = false; setEliminaFiltro();">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>

          <v-spacer />

          <!-- Pulsante di annullamento. -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on"
              @click="dialog_elimina_set_filtri = false">
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>

        <!-- Testo di conferma. -->
        <v-card-text class="mt-5 mb-0 pb-5">
          <h2 class="mt-5">
            Confermare l'eliminazione del set di filtri selezionato.
          </h2>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar. -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay caricamento. -->
    <v-overlay color="rgba(0, 0, 0, 1)" style="position: absolute" :value="caricamento_dati">
      <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
      <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

  </div>
</template>

<script>
import moment from 'moment';
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import QueryEditor from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";
const DEFAULT = "Default";
const TipoOggetto = Object.freeze({TEXT_FIELD: 0, DATA_PICKER: 1, DATA_QUERY: 2, MULTI_SELECT: 3, SELECT: 4, SELECT_NO_NULLABLE: 5});

export default {
  name: "GestioneFiltri",
  
  components: {
    SnackbarQV,
    QueryEditor
  },

  props: {
    modulo_header: { type: String, required: true, default: "" },
  },

  data() {
    return {
      // Costanti.
      DEFAULT,
      TipoOggetto,

      // Variabili di supporto.
      modulo: "",
      modulo_header_sel: "",
      nome_filtro_sel: "",
      id_filtro_sel: null,
      campo_order_by: "",
      nuovo_modulo: false,
      nuovo_filtro: false,
      caricamento_dati: false,
      caricamento_dati_dialog: false,
      query_valori: {query: null, is_analyzed: false},
      item_query_sel: null,

      // Variabili modali.
      dialog_elimina_set_filtri: false,
      dialog_order_by: false,
      dialog_query: false,

      // Array.
      headers: [
        { text: "", value: "up", width:"30px"},
        { text: "", value: "down", width:"30px"},
        { text: "Des. filtro", value: "des_filtro_dettaglio"},
        { text: "Campo tabella", value: "campo"},
        { text: "Operatore", value: "operatore", width: "150px"},
        { text: "Tipo Oggetto", value: "tipo_oggetto", width: "150px"},
        { text: "Valore", value: "valore", width: "280px"},
        { text: "Post query", value: "post_query", width: "150px"},
        { text: "Tipo filtro", value: "tipo_filtro", width: "100px"},
        { text: "Visibilità", value: "visible" },
        { text: "Disattiva", value: "validita" },
      ],

      headers_order_by: [
        {text: "Campo", value: "campo", width:"280px"},
        {text: "Ordine", value: "ordine"},
        {text: "Elimina", value: "elimina"}
      ],

      headers_query: [
        {text: "Descrizione (AS text)", value: "text", width:"280px"},
        {text: "Valore (AS value)", value: "value"},
      ],

      lista_date: [
        { text: "Giorni", value: "DAY"},
        { text: "Mesi", value: "MONTH"},
        { text: "Mesi (inizio)", value: "START_MONTH"},
        { text: "Mesi (fine)", value: "END_MONTH"},
        { text: "Anni", value: "YEAR"},
        { text: "Anni (inizio)", value: "START_YEAR"},
        { text: "Anni (fine)", value: "END_YEAR"},
      ],

      lista_ordini_order_by: [
        {text: "Crescente", value: "ASC"},
        {text: "Decrescente", value: "DESC"}
      ],
      
      lista_moduli: [],
      lista_filtri: [],
      lista_filtri_dettaglio: [],
      lista_tipi_oggetto: [],
      lista_operatori_rel: [],
      lista_order_by: [],
    };
  },

  methods: {

    aggiornaDaDefault() {
      // Filtri del set default.
      let lista_filtri_default = this.lista_filtri[this.findIndexFromDes(DEFAULT)].filtri_dettaglio;

      if(lista_filtri_default) {
        // Per ogni filtro default:
        lista_filtri_default.forEach(filtro_def => {
          // Vede il corrispondente nella lista dettaglio del set selezionato.
          let filtro = this.lista_filtri_dettaglio.find(sel => { return sel.id_default_ref == filtro_def.id_filtro_dettaglio});

          // Se il filtro esiste, aggiorna il campo e la validità.
          if(filtro) {
            filtro.campo = filtro_def.campo;
            filtro.validita = filtro_def.validita;
          } 
          // Se non esiste ed è un filtro valido, lo aggiunge.
          else {
            let filtro_copy = Object.assign({}, filtro_def);
            filtro_copy.id_default_ref = filtro_copy.id_filtro_dettaglio;
            filtro_copy.id_filtro_dettaglio = -moment().valueOf();
            this.lista_filtri_dettaglio.push(filtro_copy);
          }
        });
      }
    },

    aggiornaFiltriDettaglio() {
      this.lista_filtri_dettaglio = [];

      // Controlla che esista il set di filtri all'indice corrispondente.
      if(this.lista_filtri[this.findIndexFromId(this.id_filtro_sel)]) {
        var filtri_dettaglio = this.lista_filtri[this.findIndexFromId(this.id_filtro_sel)].filtri_dettaglio;

        // Aggiorna anche nome_filtro_sel per identificare un eventuale "Default".
        this.nome_filtro_sel = this.lista_filtri[this.findIndexFromId(this.id_filtro_sel)].des_filtro;
      } else this.nome_filtro_sel = "";
      
      // Controlla che esista filtri_dettaglio, se sì viene popolato.
      if(filtri_dettaglio)
        this.lista_filtri_dettaglio = [...filtri_dettaglio];
    },

    // Converti i valori di data query dai due form al formato stringa.
    aggiornaValoreDataQuery(e, item, is_num) {
      var tmp_val = ["0","DAY"];
      if(item.valore) tmp_val = item.valore.split("/");
      if(is_num) tmp_val[0] = e;
      else tmp_val[1] = e;
      item.valore = tmp_val[0] + "/" + tmp_val[1];
    },
    
    aggiungiFiltro() {
      // Controllo che il set di filtri sia selezionato.
      if (!this.modulo) {
        this.$refs.SnackbarQV.print("orange", "Selezionare un modulo prima di aggiungere un nuovo set di filtri.");
        return;
      }
      this.nuovo_filtro = true;
      this.lista_filtri_dettaglio = [];

      // Crea un set di default.
      this.lista_filtri.push({
        id_filtro: -1,
        modulo: this.modulo,
        des_filtro: "",
        validita: 1,
        filtri_dettaglio: []
      });

      // Imposta filtro_dettaglio del set attuale.
      this.id_filtro_sel = -1;

      // Eredita i filtri_dettaglio dal set di filtri "Default".
      this.lista_filtri_dettaglio = [...this.lista_filtri[this.findIndexFromDes(DEFAULT)].filtri_dettaglio];
      this.lista_filtri_dettaglio .forEach(e => {
          e.id_filtro = this.id_filtro_sel;
          e.id_default_ref = e.id_filtro_dettaglio;
          e.id_filtro_dettaglio = -moment().valueOf();
      });
    },

    aggiungiNuovoModulo() {
      // Svuota tutte le informazioni.
      this.nuovo_modulo = true;
      //this.modulo = "";
      this.lista_filtri = [];
      this.lista_filtri_dettaglio = [];
      this.nome_filtro_sel = DEFAULT;

      // Crea un set di default.
      this.lista_filtri.push({
        id_filtro: -1,
        modulo: this.modulo,
        des_filtro: this.nome_filtro_sel,
        filtri_dettaglio: []
      });

      // Imposta filtro_dettaglio del set attuale.
      this.id_filtro_sel = -1;
    },

    aggiungiFiltroDettaglio() {
      this.lista_filtri_dettaglio.push({
          id_filtro: this.id_filtro_sel,
          id_default_ref: null,
          ordine: null,
          id_filtro_dettaglio: -moment().valueOf(),
          des_filtro_dettaglio: null,
          campo: null,
          operatore: null,
          tipo_oggetto: TipoOggetto.TEXT_FIELD,
          valore: null,
          tipo_filtro: null,
          query_tabella: null,
          visible: 1,
          validita: 1
      });
    },

    analizzaQuery(status) {
      this.query_valori.is_analyzed = !status;
    },

    checkSalvaOrderBy() {
      var check_order_by = true;
      this.lista_order_by.forEach(e => {
        if(!e.campo) { 
          check_order_by = false;
          this.$refs.SnackbarQV.print('orange', '"Campo" dev\'essere compilato.');
        }
      });

      if(check_order_by) {
      this.dialog_order_by = false; 
      if(this.lista_filtri[this.findIndexFromId(this.id_filtro_sel)])
        this.lista_filtri[this.findIndexFromId(this.id_filtro_sel)].order_by = this.convertiOrderBy(true);
        this.lista_order_by = [];
      }
    },

    // Converti i valori di data query da stringa a formato leggibile dal form.
    convertiDataQuery(val, is_num) {
      if(val) {
        var data_query = val.split("/");
        if(is_num) return data_query[0];
        else return data_query[1];
      }
    },

    // Converti i valori della multi-select (lista -> stringa).
    convertiMultiSelectString(list) {
        var str = "";
        list.forEach(e => {str += e.toString() + ",";});
        str = str.slice(0, -1); // Toglie l'ultima virgola.
        return str;
    },

    // Converti i valori della multi-select (stringa -> lista).
    convertiMultiSelectList(str) {
      return str.split(",");
    },
    
    // Converti ORDER BY (stringa -> lista) (lista -> stringa).
    convertiOrderBy(to_string, str = "") {

      if(to_string) {
        // Per ogni campo, crea un ordine in stringa.
        this.lista_order_by.forEach(e => {
          e.campo = e.campo.trim();
          e.ordine = e.ordine.trim();
          str += e.campo + " " + e.ordine + ",";
        });

        // Toglie l'ultima virgola.
        str = str.slice(0, -1);

        return str;
      } else {
        // Divide le parole a seconda delle virgole.
        var tmp_lista_order_by = [];
        if(str) tmp_lista_order_by = str.split(",");

        // Aggiungi gli elementi nella lista.
        tmp_lista_order_by.forEach(e => {
          var simboli = e.split(" "); 
          this.lista_order_by.push({
            campo: simboli[0],
            ordine: simboli[1]
          });
        });
      }
    },

    eseguiQuery(item, from_dialog_query) {

      if(this.query_valori.query.includes('{') && this.query_valori.query.includes('}') ) return;
      
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "performquery",
          query_string: this.query_valori.query,
          token: localStorage.user_token,
        },
      };

      if(from_dialog_query) this.caricamento_dati_dialog = true;
      else this.caricamento_dati = true;

      this.$store.dispatch("api", request).then((res) => {

        if(from_dialog_query) this.caricamento_dati_dialog = false;
        else this.caricamento_dati = false;

        if (res.data.result != null) {
          item.lista_query = res.data.result.Table;
          if(item.lista_query) {
            // Qualsiasi risultato (int, float, ecc...) dev'essere convertito in stringa.
            item.lista_query.forEach(e => {e.value = e.value ? e.value.toString() : null;});
            // Riordina in ordine alfabetico.
            // item.lista_query.sort((a, b) => (a.text ? a.text : "").localeCompare((b.text ? b.text : "")));
          }
        } else {
          this.$refs.SnackbarQV.print("orange", "Nessuna query trovata.");
        }
        
        if(!from_dialog_query) this.aggiornaFiltriDettaglio();
      }).catch((err) => {

        if(from_dialog_query) this.caricamento_dati_dialog = false;
        else this.caricamento_dati = false;

        console.log(item);
        this.$refs.SnackbarQV.print("error", err +": ricontrollare che la query sia scritta correttamente.");
      });
    },

    findIndexFromId(id) {
      return this.lista_filtri.findIndex(set_filtri => { return set_filtri.id_filtro === id; });
    },
    findIndexFromDes(des) {
      return this.lista_filtri.findIndex(set_filtri => { return set_filtri.des_filtro === des; });
    },

    getRicaricamentoFiltri() {
      if(this.modulo_header_sel != this.modulo_header) {
        this.modulo_header_sel = this.modulo_header;
        this.id_filtro_sel = null;
        this.getListaModuli();
        this.getTabella();
      }
    },

    getFiltri() {
      this.caricamento_dati = true;
      this.lista_filtri = [];

      let request = {
        controller: "magazzino",
        method: "POST",
        richiesta: {
          action: "getfiltri",
          token: localStorage.getItem("user_token"),
          modulo: this.modulo
        },
      };

      this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.caricamento_dati = false;

          if(res.status == 200) {
            this.lista_filtri = res.data.result.lista ? res.data.result.lista : [];

            if(this.lista_filtri.length == 0) {
              this.aggiungiNuovoModulo();
              return; 
            }

            // Se nessun filtro è stato precedentemente selezionato, prende quello "Default".
            if(!this.id_filtro_sel)
              this.id_filtro_sel = this.lista_filtri[this.findIndexFromDes(DEFAULT)].id_filtro;

            // Per ogni filtro dettaglio, aggiunge una lista query per popolare le multi-select.
            this.lista_filtri.forEach(f => {
              f.filtri_dettaglio.sort((a, b) => a.ordine - b.ordine)
              f.filtri_dettaglio.forEach(fd => {
                fd.lista_query = [];

                if(fd.tipo_oggetto == TipoOggetto.MULTI_SELECT || 
                  fd.tipo_oggetto == TipoOggetto.SELECT || 
                  fd.tipo_oggetto == TipoOggetto.SELECT_NO_NULLABLE) {

                  // Ottiene la tabella degli elementi completa dalla query.
                  if(fd.query_tabella) {
                    this.query_valori.query = fd.query_tabella;
                    this.eseguiQuery(fd, false);
                  }

                  // Converti stringa in lista se oggetto MULTI-SELECT.
                  if(fd.valore && fd.tipo_oggetto == TipoOggetto.MULTI_SELECT)
                    fd.valore = this.convertiMultiSelectList(fd.valore);
                }
              });
            });

            this.aggiornaFiltriDettaglio();
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },

    getListaModuli() {
      this.caricamento_dati = true;
      var request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getmoduliheader",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status == 200) {
            this.lista_moduli = res.data.result;
            this.modulo = this.modulo_header;

            // La getFiltri() viene fatta collateralmente alla getModuli.
            this.getFiltri();
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.log("Errore:");
          console.log(err);
        });
    },

    getTabella() {
      //this.caricamento_dati = true;
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.user_token,
          tipo: "'TIPO_OGGETTO_FILTRI','OPERATORI_REL'",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          //this.caricamento_dati = false;
          if (res.status === 200) {
            if (res.data) {
              this.lista_tipi_oggetto = res.data.TIPO_OGGETTO_FILTRI ? res.data.TIPO_OGGETTO_FILTRI : new Array();
              this.lista_tipi_oggetto.sort((a, b) => a.val_int - b.val_int); 

              this.lista_operatori_rel = res.data.OPERATORI_REL ? res.data.OPERATORI_REL : new Array();
              this.lista_operatori_rel.sort((a, b) => a.val_int - b.val_int); 
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          //this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },

    setEliminaFiltro() {
      let set_di_filtri = this.lista_filtri[this.findIndexFromId(this.id_filtro_sel)];
      if(!set_di_filtri){
        this.$refs.SnackbarQV.print("orange", "Assicurati che il modulo e il set di filtri siano validi.");
        return;
      }
      set_di_filtri.validita = 0;
      // Imposta la validità a 0 anche ai filtri_dettaglio.
      this.lista_filtri_dettaglio.forEach(e => {e.validita = 0;});
      set_di_filtri.filtri_dettaglio = this.lista_filtri_dettaglio;

      this.caricamento_dati = true;
      let request = {
        controller: "magazzino",
        method: "PUT",
        richiesta: {
          action: "setfiltri",
          filtri: [set_di_filtri],
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("api6", request).then((res) => {
        this.caricamento_dati = false;
        if (res.status == 200) {
          this.lista_filtri_dettaglio = [];
          this.lista_filtri = []; 
          this.getListaModuli();
          this.$refs.SnackbarQV.print("success", "Set di filtri rimosso con successo.");
        } else {
          this.$refs.SnackbarQV.print("error", "Errore nel salvataggio.");
        }
      });
    },

    setFiltro() {
      let set_di_filtri = this.lista_filtri[this.findIndexFromId(this.id_filtro_sel)];

      // Check campi.
      if(!set_di_filtri) {
        this.$refs.SnackbarQV.print("orange", "Assicurati che il modulo e il set di filtri siano validi.");
        return;
      }
      if(!this.modulo && this.nuovo_modulo) {
        this.$refs.SnackbarQV.print("orange", "Inserisci un nome valido per il modulo.");
        return;
      }

      if(set_di_filtri.des_filtro == DEFAULT && this.nuovo_filtro) {
        this.$refs.SnackbarQV.print("orange", DEFAULT + " è riservato.");
        return;
      }
      if(!set_di_filtri.des_filtro && this.nuovo_filtro) {
        this.$refs.SnackbarQV.print("orange", "Inserisci un nome valido per il set di filtri.");
        return;
      }

      // Imposta come modulo del set di filtri corrente, il modulo selezionato.
      set_di_filtri.modulo = this.modulo;

      // ID randomici nuovi a -1.
      this.lista_filtri_dettaglio.forEach(e => {
        if(e.id_filtro_dettaglio < 0) e.id_filtro_dettaglio = -1;

        // Li mette in ordine.
        e.ordine = this.lista_filtri_dettaglio.indexOf(e);

        // Nel caso di una multi-select, converte il valore in stringa.
        if(e.tipo_oggetto == TipoOggetto.MULTI_SELECT)
          e.valore = e.valore ? this.convertiMultiSelectString(e.valore) : null;

        // Cancella la lista "query_list" dall'oggetto poiché usata solo per variabile locale e non necessaria per la chiamata.
        delete e.lista_query;
      });

      // Aggiungi tutti i filtri all'interno dell'oggetto da mandare.
      set_di_filtri.filtri_dettaglio = this.lista_filtri_dettaglio;
      
      this.caricamento_dati = true;
      let request = {
        controller: "magazzino",
        method: "PUT",
        richiesta: {
          action: "setfiltri",
          filtri: [set_di_filtri],
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api6", request).then((res) => {
        this.caricamento_dati = false;
        if (res.status == 200) {
          this.lista_filtri_dettaglio = [];
          if(this.nuovo_modulo) {
            this.nuovo_modulo = false;
            this.modulo = '';
            this.lista_filtri = []; 
          }
          if(this.nuovo_filtro) {
            this.nuovo_filtro = false;
            this.lista_filtri = []; 
          }
          this.getListaModuli();
          this.$refs.SnackbarQV.print("success", "Salvataggio effettuato.");
        } else {
          this.$refs.SnackbarQV.print("error", "Errore nel salvataggio.");
        }
      });
    },

    spostaOrdineFiltro(is_up, item) {
      let i = is_up ? -1 : 1;
      let tmp_item = Object.assign({}, item);
      Object.assign(item, this.lista_filtri_dettaglio[this.lista_filtri_dettaglio.indexOf(item) + i]);
      Object.assign(this.lista_filtri_dettaglio[this.lista_filtri_dettaglio.indexOf(item) + i], tmp_item);

      console.log(this.lista_filtri_dettaglio);
    },
  },

  // watch: {
  //   modulo_header: {
  //     immediate: true,
  //     handler() {
  //       this.getListaModuli();
  //       this.getTabella();
  //     }
  //   }
  // }
};
</script>

<style scoped>
/* Overlay */
@keyframes ConsuntivoWOControtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes ConsuntivoWORotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ConsuntivoWOControruota {
  animation: ConsuntivoWOControtazione 1s infinite;
  animation-timing-function: linear;
}

.ConsuntivoWORuota {
  animation: ConsuntivoWORotazione 1s infinite;
  animation-timing-function: linear;
}
/* *** */
</style>
